import React from 'react';
import { PartyPopper } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

// Shown only during the Mon/Tue free-access window, for any logged-in account.
// Driven by the backend `free_access_day` flag (single source of truth for the day).
export default function FreeAccessBanner() {
  const { user } = useAuth();
  if (!user || typeof user !== 'object' || !user.free_access_day) return null;

  return (
    <div
      data-testid="free-access-banner"
      className="w-full bg-gradient-to-r from-emerald-600 to-emerald-500 text-white text-center px-4 py-2 flex items-center justify-center gap-2 shadow-md"
    >
      <PartyPopper size={16} className="flex-shrink-0" />
      <span className="text-sm font-semibold">
        Free Access Today — IntelliTix &amp; IntelliTix Pro are free every Monday &amp; Tuesday for all members.
      </span>
    </div>
  );
}
